import { useEffect, useCallback, useState } from 'react';

import styles from './index.module.sass';

import PROMO_IMAGE from './contador-img.png';

export default function CountDown({ target_date, setShowCount, screenSize }) {
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  function pad(n) {
    if (n < 0) return n;
    return (n < 10 ? '0' : '') + n;
  }

  const getCountdown = useCallback(() => {
    // find the amount of "seconds" between now and target
    var current_date = new Date().getTime();
    if (target_date < current_date) {
      setShowCount(false);
      return;
    }

    var seconds_left = (target_date - current_date) / 1000;

    setHours(pad(parseInt(seconds_left / 3600)));
    seconds_left = seconds_left % 3600;

    setMinutes(pad(parseInt(seconds_left / 60)));
    setSeconds(pad(parseInt(seconds_left % 60)));
  }, [target_date, setShowCount]);

  const initialCountdown = useCallback(() => {
    getCountdown();

    setInterval(function () {
      getCountdown();
    }, 1000);
  }, [getCountdown]);

  useEffect(() => {
    initialCountdown();
  }, [initialCountdown]);

  return (
    <>
      <div className={`${styles.promoCountDown} ${styles[screenSize]}`}>
        <div className={styles.labelContainer}>
          <div className={styles.label}>Válido para nuevos ingresos 27 y 28 de noviembre 2024</div>
        </div>
        <div>
          <img src={PROMO_IMAGE} alt='Promo' className={styles.promoImg} />
        </div>
        <div className={styles.right}>
          <div className={styles.cdPromoTitle}>
            <div className={styles.cdtitle1}>QUEDAN POCAS HORAS</div>
            <div className={styles.cdtitle2}>¡APROVECHA YA!</div>
          </div>
          <div id={styles.countdown}>
            <div id={styles.tiles}>
              <span>{hours}</span>
              <span>{minutes}</span>
              <span>{seconds}</span>
            </div>
            <div className={styles.labels}>
              <li>Horas</li>
              <li>Mins</li>
              <li>Segs</li>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
